export default {
  computed: {
    getSelectedJackpotId() {
      return this.$store.getters["page/getSelectedJackpotId"];
    },
    getSelectedTheme() {
      return this.$store.getters["page/getSelectedTheme"];
    },
    getFilteredMachineList() {
      // return this.$store.getters["machine/getMachineList"];
      let filteredList = this.$store.getters["machine/getMachineList"];

      // 선택된 테마에 따른 필터링
      if (this.getSelectedTheme !== "all") {
        filteredList = filteredList.filter(
          (machine) => machine.gameId === this.getSelectedTheme,
        );
      }

      if (this.getSelectedJackpotId !== "all") {
        filteredList = filteredList.filter(
          (machine) => machine.jackpotId === this.getSelectedJackpotId,
        );
      }

      // 즐겨찾기 필터링
      if (this.getIsFilteredFavorite) {
        filteredList = filteredList.filter(
          (machine) => machine.isFavorite === true,
        );
      }
      return filteredList;
    },
    getIsFilteredFavorite() {
      return this.$store.getters["page/getIsFilteredFavorite"];
    },
  },
  methods: {
    updateSelectedJackpot(jackpotId) {
      this.$store.commit("page/setSelectedJackpotId", jackpotId);
    },
    updateSelectedTheme(themeId) {
      this.$store.commit("page/setSelectedTheme", themeId);
    },
    handleFilteredMachines(filteredList) {
      this.$store.commit("page/setFilteredMachineList", filteredList);
    },
    toggleFavorite() {
      this.$store.commit("page/setIsFilteredFavorite", !this.getIsFilteredFavorite);
    },
  },
};
